import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap';
import useManageDrugs from '../../hooks/patientDashboard/useMangeDrugs';
import Spinner1 from './spinners';
import moment from 'moment'

const MedicationHistorySidebar = () => {
 const { drugs, loading, handleFetchDrugs } = useManageDrugs();

 useEffect(() => {
  handleFetchDrugs()
}, [])
    
console.log("console",drugs)

  return (
    <Col xl="" className="d-none app-sideba d-xl-block">
      <div className="data-sidebar-card">
        <h5 className="data-sidebar-title">Recent Medications</h5>
        <div className="data-sidebar-stack">
          {loading ? (
            <div className="w-100 d-flex justify-content-center py-4">
              <Spinner1 />
            </div>
          ) : !drugs?.result?.length ? (
            <div className='data-sidebar-item text-center text-muted'>No result found</div>
          ) : (
            drugs?.result?.slice(0,3)?.map((item, index)=>(
              <div key={index} className="data-sidebar-item">
                <span className="data-status-badge is-success mb-2">Prescription</span>
                <div className="data-cell-title">
                  {item?.requests?.slice(0,1)?.map(request => request?.item?.vaccine?.name_of_vaccine || request?.item?.drug?.name || "---")}
                </div>
                <div className="data-cell-meta">{moment(item?.created_at || "---").format("D MMM, YYYY")}</div>
                <p className="fs-xs mb-0 mt-2 text-capitalize">
                  Consultant: Dr.{item?.requests.slice(0,1)?.map(request => request?.createdBy || "---")}
                </p>
              </div>
            ))
          )}
        </div>
      </div>

    </Col>
  )
}

export default MedicationHistorySidebar
